export default {"src":"/_next/static/media/Austria.85bf4c93.svg","height":15,"width":20,"blurWidth":0,"blurHeight":0};